import { defineMessages } from 'react-intl-next';

export const i18nCommonStrings = defineMessages({
	archiveInheritedRestrictionsInfoLinkAriaDescription: {
		id: 'archive-pages.dialog.archive.inherited-restrictions.info.link.aria-description',
		defaultMessage: 'inherited view restrictions - link opens in a new tab',
		description:
			'Aria-label description of the Inherited View Descriptions support link and what it will do when clicked.',
	},
});
